import { DATA_HOOKS } from './dataHooks';

export * from './Dialog';
export const DIALOG_DATA_HOOKS = DATA_HOOKS;
